module.exports = __webpack_public_path__ + "static/img/wolves.a011b33.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/common/bg/wolves.png
// module id = /9Rc
// module chunks = 1